import { render, staticRenderFns } from "./ItemsPurchasedTogether.vue?vue&type=template&id=9339b412&scoped=true"
import script from "./ItemsPurchasedTogether.vue?vue&type=script&lang=js"
export * from "./ItemsPurchasedTogether.vue?vue&type=script&lang=js"
import style0 from "./ItemsPurchasedTogether.vue?vue&type=style&index=0&id=9339b412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9339b412",
  null
  
)

export default component.exports